import React from 'react';

const AwaitingApproval = () => {
  return (
    <div className="awaiting-approval">
      <h2>Your account is under review</h2>
      <p>Please wait while our team reviews your submission. You will be notified once your account is approved.</p>
    </div>
  );
};

export default AwaitingApproval;
